import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Index from '@pages/index.js';
import Sales from '@pages/sales/index.js';
import Products from '@pages/products/index.js';
import Water from '@pages/products/water/index.js';
import Order from '@pages/order/index.js';
import About from '@pages/info/about/index.js';
import Contacts from '@pages/info/contacts/index.js';
import Delivery from '@pages/info/delivery/index.js';
import Payment from '@pages/info/payment/index.js';
import Page404 from '@pages/404/index.js';
import Page403 from '@pages/403/index.js';
import Personal from '@pages/personal/index.js';
import History from '@pages/history/index.js';
import FAQ from '@pages/info/faq/index.js';
import Refund from '@pages/info/refund/index.js';
import Warranty from '@pages/info/warranty/index.js';
import Privacy from '@pages/info/privacy/index.js';
import Friend from '@pages/info/bring-a-friend/index.js';
import Catalog from '@pages/products/_id/index.js';
import ProductId from '@pages/products/_id/_id/index.js';

const routes = [
  {
    path: '/',
    name: 'main',
    component: Index,
  },
  {
    path: '/404',
    name: 'page404',
    component: Page404,
  },
  {
    path: '/403',
    name: 'page403',
    component: Page403,
  },
  {
    path: '/products',
    name: 'products',
    component: Products,
  },
  {
    path: '/sales',
    name: 'sales',
    component: Sales,
  },
  {
    path: '/info/about',
    name: 'about',
    component: About,
  },
  {
    path: '/info/contacts',
    name: 'contacts',
    component: Contacts,
  },
  {
    path: '/info/bring-a-friend',
    name: 'bring-a-friend',
    component: Friend,
  },
  {
    path: '/info/delivery',
    name: 'delivery',
    component: Delivery,
  },
  {
    path: '/info/payment',
    name: 'payment',
    component: Payment,
  },
  {
    path: '/info/refund',
    name: 'refund',
    component: Refund,
  },
  {
    path: '/info/warranty',
    name: 'warranty',
    component: Warranty,
  },
  {
    path: '/info/privacy',
    name: 'privacy',
    component: Privacy,
  },
  {
    path: '/products/water',
    name: 'water',
    component: Water,
  },
  {
    path: '/order',
    name: 'order',
    component: Order,
  },
  {
    path: '/personal',
    name: 'personal',
    component: Personal,
  },
  {
    path: '/info/faq',
    name: 'faq',
    component: FAQ,
  },
  {
    path: '/history',
    name: 'history',
    component: History,
  },
  {
    path: '/products/:id',
    name: 'catalog-id',
    component: Catalog,
  },
  {
    path: '/products/:id/:id2',
    name: 'products-id',
    component: ProductId,
  },
];

export const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.name === from.name) {
      return {};
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});



// WEBPACK FOOTER //
// ./src/routes.js